import React from 'react'
import { Link } from 'react-router-dom'

const LowStockNotificationModal = ({drugList, setModal}) => {
  return (
    <div className="modal fade" id="add-customer" onClick={()=>setModal(false)}>
      <div className="modal-dialog" style={{minWidth:"430px"}} onClick={(e)=>e.stopPropagation()}>
        <div className="modal-content px-3" style={{maxHeight:'500px', overflow:"auto"}}>
          <div className="modal-header">
            <h5 className="modal-title">Low Stock Drugs</h5>
            
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
                onClick={() => setModal(false)}
              >
                ×
              </span>
            </button>
          </div>
          <div className="modal-body">
          <p>You have {drugList?.length} Drugs that are low in stock!!!</p>
            <ul>
                {
                    drugList?.map((drug, index)=>(

                        <li key={index}>
                            <Link to={`/medicine/${drug?.id}/details`}>
                                {drug?.name}
                            </Link>
                            <p>
                              Quantity Left: {drug?.quantity}
                            </p>
                        </li>
                    ))
                }
                
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LowStockNotificationModal